const GA_MEASUREMENT_ID = "G-Q7CRK9F8L6";

const analyticsReady = () =>
  typeof window !== "undefined" && typeof window.gtag === "function";

const cleanParams = (params = {}) =>
  Object.fromEntries(
    Object.entries(params).filter(([, value]) =>
      value !== undefined && value !== null && value !== ""
    )
  );

export const trackPageView = (pagePath, pageTitle) => {
  if (!analyticsReady()) return;

  const safePath = pagePath.startsWith("/") ? pagePath : `/${pagePath}`;

  window.gtag("event", "page_view", {
    send_to: GA_MEASUREMENT_ID,
    page_title: pageTitle,
    page_location: `${window.location.origin}${safePath}`,
    page_path: safePath,
  });
};

export const trackEvent = (eventName, params = {}) => {
  if (!analyticsReady()) return;

  window.gtag("event", eventName, {
    send_to: GA_MEASUREMENT_ID,
    ...cleanParams(params),
  });
};
